<script setup></script>

<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8359 4.16797H4.16927C3.02344 4.16797 2.09635 5.10547 2.09635 6.2513L2.08594 18.7513C2.08594 19.8971 3.02344 20.8346 4.16927 20.8346H20.8359C21.9818 20.8346 22.9193 19.8971 22.9193 18.7513V6.2513C22.9193 5.10547 21.9818 4.16797 20.8359 4.16797ZM20.4193 8.59505L13.0547 13.1992C12.7214 13.4076 12.2839 13.4076 11.9505 13.1992L4.58594 8.59505C4.48149 8.53642 4.39002 8.4572 4.31707 8.36219C4.24412 8.26718 4.19121 8.15836 4.16154 8.04231C4.13186 7.92626 4.12604 7.8054 4.14443 7.68704C4.16282 7.56868 4.20504 7.45527 4.26852 7.3537C4.33201 7.25212 4.41544 7.16448 4.51378 7.09609C4.61211 7.02769 4.7233 6.97996 4.84062 6.95578C4.95794 6.9316 5.07894 6.93148 5.19631 6.95541C5.31367 6.97935 5.42496 7.02686 5.52344 7.09505L12.5026 11.4596L19.4818 7.09505C19.5802 7.02686 19.6915 6.97935 19.8089 6.95541C19.9263 6.93148 20.0473 6.9316 20.1646 6.95578C20.2819 6.97996 20.3931 7.02769 20.4914 7.09609C20.5898 7.16448 20.6732 7.25212 20.7367 7.3537C20.8002 7.45527 20.8424 7.56868 20.8608 7.68704C20.8792 7.8054 20.8733 7.92626 20.8437 8.04231C20.814 8.15836 20.7611 8.26718 20.6881 8.36219C20.6152 8.4572 20.5237 8.53642 20.4193 8.59505Z"
      fill="white"
    />
  </svg>
</template>

<style scoped></style>
